/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import {
    type OnChanges,
    type SimpleChanges,
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
    ViewChild,
} from '@angular/core';
import { I18nService, TimeService } from '@dm/core';
import moment from 'moment';

@Component({
    selector: 'app-infigo-error-display',
    templateUrl: './error-display.component.html',
    styleUrls: ['./error-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorDisplayComponent implements OnChanges {
    @Input() isFocus = false;
    @Input() value;
    @Input() error;
    @Input() tip;
    @ViewChild('scrollElement') scrollElement;
    @Output() onTimeSelectChange = new EventEmitter();
    selectAble = true;
    dataValue = moment();

    constructor(public i18n: I18nService, public time: TimeService) {
    }

    getPreValue(): string {
        if (!this.error) {
            return this.value;
        }

        const index = this.value.lastIndexOf(this.error.value);

        return this.value.slice(0, index);
    }

    getNextValue(): string {
        if (!this.error) {
            return '';
        }

        const index = this.value.lastIndexOf(this.error.value);

        return this.value.slice(index + this.error.value.length);
    }

    scroll(value: string | number): void {
        this.scrollElement.nativeElement.scrollLeft = value;
    }

    getTip(tip: string): string {
        const reg = /i18n\.get\((\S+)\)/;

        if (reg.test(tip)) {
            return tip.replace(reg, this.i18n.get(RegExp.$1));
        }

        return tip;
    }

    selectTime(time: { format: (arg0: string) => any }): void {
        this.selectAble = false;
        this.onTimeSelectChange.emit(time.format('YYYY-MM-DD'));
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.value) {
            const str = this.value;
            const result = /[<>]/g.exec(str);

            if (!result) {
                return;
            }

            const dateStr = str.slice(result.index + 1);
            this.selectAble = !dateStr;
        }
    }
}
